import React, {useEffect, useMemo, useRef, useState} from 'react';
import { v4 as uuid } from 'uuid'
import { addItem } from './Tree/utilities.ts';
import { TreeItem, TreeItems } from './Tree/types.ts';

export default function saveTaskItemsToLocalStorage(items) {
  // TODO: Put this code in it's own function so it's handy in this utils file if I ever need it.
  // const DBDeleteRequest = window.indexedDB.deleteDatabase("TasksDB");

  // DBDeleteRequest.onerror = (event) => {
  //   console.error("Error deleting database.");
  // };

  // DBDeleteRequest.onsuccess = (event) => {
  //   console.log("Database deleted successfully");

  //   console.log(event.target.result); // should be undefined
  // };

  const dbOpenRequest = window.indexedDB.open("TasksDB",1);

  let db;

  dbOpenRequest.onerror = (event) => {
    console.error(`Database error: ${event.target.error?.message}`);
    alert("Issue connecting to DB!!");
  };

  dbOpenRequest.onsuccess = (event) => {
    db = event.target.result;
    console.log('DB connection opened for updating!!');

  // This assumes the objectStore has already been successfully created in the DB
  // TODO: handle the exception if not.
  const objectStore = db
    .transaction("TaskNestedLists", "readwrite")
    .objectStore("TaskNestedLists");
    
    console.log('Got object store on save tasks call!! '+ objectStore);
    const storedItems = event.target.result;
    // objectStore.clear();
    console.log('Items obtained from DB: '+storedItems);
    const requestUpdate = objectStore.put(items,1);
    requestUpdate.onsuccess = (event) => {
      // Success - the data is updated!
    };

  };

  dbOpenRequest.onupgradeneeded = (event) => {
    db = event.target.result;
    alert("DB was upgraded!!");
    console.log("DB was upgraded!!");

    const objectStore = db.createObjectStore("TaskNestedLists",  { keypath: false, autoIncrement: false });

    // Wait for objectStore to be created.
    objectStore.transaction.oncomplete = (event) => {
      const objectStore = db
      .transaction("TaskNestedLists", "readwrite")
      .objectStore("TaskNestedLists");
    
      console.log('Got object store on save tasks call!! '+ objectStore);
      const storedItems = event.target.result;
      console.log('Items obtained from DB: '+storedItems);
      const requestUpdate = objectStore.put(items,1);
      requestUpdate.onsuccess = (event) => {
        // Success - the data is updated!
      };
    }

  };  
}